import { useState, useEffect } from "react";
import { getAuth, onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import { app } from "../firebase/firebase";


const auth = getAuth(app);

export default function SignupPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);  // To store the current user

  // Check if the user is logged in
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);  // Set user object to state
    });

    // Cleanup the subscription on component unmount
    return () => unsubscribe();
  }, []);

  // Handle user sign-up
  const createUser = () => {
  signInWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
      })
      .catch((error) => {
        alert(error.message);  // Show error if sign-up fails
      });
  };


  return (
    <div className="flex justify-center items-center h-screen bg-[rgb(247,247,247)]">
    <div className="w-full max-w-[21rem]  bg-white rounded-xl shadow-2xl px-8 pb-12 pt-9">
      
      <h1 className="text-[35px] font-semibold text-blue-600 mb-[24px] ">
        Sign In
      </h1>
      
        <div className="mb-4">
          <label className="block text-md font-medium text-gray-700">
            Email
          </label>
          <input
            value={email}
            type="email"
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-5 py-2 border border-gray-300 rounded-md"
            required
            placeholder="Enter your email"
          />
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-gray-700">
            Password
          </label>
          <input
            value={password}
            type="password"
            onChange={(e) => setPassword(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md"
            required
            placeholder="Enter your password"
          />
        </div>
        <div className="justify-center flex">
        <button
          type="submit"
          className="w-full  bg-customblue text-white px-4 py-3 rounded-md hover:bg-blue-700"
          onClick={createUser}
        >
          Sign In
        </button>
        </div>
      </div>
    </div>
  );
}
